import http from "../../../../../http-common.js";

class MasterDataService {
  getBranchList(payload) {
    const { filter } = payload;
    const keyword =
      filter?.search === "" || filter?.search === undefined
        ? ""
        : `?keyword=${filter?.search}`;
    return http.get(`/api/v1/branch/list${keyword}`);
  }

  createBranch(data) {
    return http.post("/api/v1/backoffice/branch/create", data);
  }
  editBranch(id, data) {
    return http.put("/api/v1/backoffice/branch/update/" + id, data);
  }

  createDepo(data) {
    return http.post("/api/v1/backoffice/csc/create", data);
  }

  getDepoList(id) {
    return http.get("/api/v1/csc/list/for/" + id);
  }

  editDepo(id, data) {
    return http.put("/api/v1/backoffice/csc/update/" + id, data);
  }

  getDepoListAll(payload) {
    const { filter } = payload;
    const keyword =
      filter?.search === "" || filter?.search === undefined
        ? ""
        : `?keyword=${filter?.search}`;
    return http.get(`/api/v1/csc/list${keyword}`);
  }
}

export default new MasterDataService();
